import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VerificationComponent } from 'src/app/components/verification/verification.component';

@Component({
  selector: 'app-catalog-suggestion-review',
  templateUrl: './catalog-suggestion-review.component.html',
  styleUrls: [ './catalog-suggestion-review.component.scss' ],
})
export class CatalogSuggestionReviewComponent {
  @Input() course: any;
  @Input() showStatusRow: any = false;

  constructor( public dialog: MatDialog) {}

  formatDate(date: any): string {
    return new Date(date).toLocaleDateString();
  }

  formatTime(timeString: string): string {
    if (!timeString) return '';
    
    // Handle "Anytime" case
    if (timeString === 'Anytime') return 'Anytime';
    
    // Parse 24-hour format (HH:MM) and convert to 12-hour format with AM/PM
    const [hours, minutes] = timeString.split(':');
    if (!hours || !minutes) return timeString;
    
    const hour24 = parseInt(hours, 10);
    const hour12 = hour24 % 12 || 12;
    const ampm = hour24 >= 12 ? 'PM' : 'AM';
    
    return `${hour12}:${minutes} ${ampm}`;
  }

  viewReason() {
    this.dialog.open(VerificationComponent, {
      data: {
        title: 'Reason for Denial',
        text: this.course?.statusComments,
        icon: 'info',
        confirmButtonTitle: 'Ok',
      },
    });

  }


}
